import {Component, OnInit} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {AnteilseignerDetail} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-laufende-nummer',
  templateUrl: './laufende-nummer.component.html'
})
export class LaufendeNummerComponent extends FormBaseComponent<AnteilseignerDetail> implements OnInit {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      laufendeNummer: [this.data?.laufendeNummer, [
        this.validatorService.maxLength(51)
      ]]
    });
  }
}
